import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-slate-800 px-4 sm:px-6 lg:px-8 relative border-t border-slate-700/50" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16" data-id="element-144">
          <p className="text-xl md:text-2xl text-slate-300 leading-relaxed font-medium border-l-4 border-amber-500 pl-6" data-id="element-145">
            Si estás cansado de ganar el sueldo mínimo y ver cómo otros latinos
            progresan conduciendo "trocas" grandes por la I-95, detente un
            segundo. El camino a los{' '}
            <strong className="text-white" data-id="element-146">$100,000 anuales</strong> está a solo
            un examen de distancia, pero el manual oficial del DMV es tu peor
            enemigo.
          </p>
          <p className="mt-6 text-lg text-slate-400" data-id="element-147">
            No necesitas ser un ingeniero mecánico ni hablar inglés perfecto
            para obtener tu licencia comercial. Necesitas un sistema de
            reconocimiento de patrones diseñado para ganar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="bg-slate-900 rounded-2xl p-8 md:p-10 border border-slate-700 shadow-xl relative overflow-hidden" data-id="element-148">
          <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-149">
            <AlertTriangle className="w-32 h-32 text-red-500" data-id="element-150" />
          </div>

          <h2 className="text-3xl md:text-4xl font-oswald font-bold text-white mb-6 uppercase flex items-center gap-3" data-id="element-151">
            <AlertTriangle className="text-amber-500 w-8 h-8" data-id="element-152" />
            El Problema Real
          </h2>

          <div className="space-y-6 text-lg text-slate-300 relative z-10" data-id="element-153">
            <p data-id="element-154">
              La mayoría de los hispanos fallan el examen del DMV en su primer
              intento. No es por falta de capacidad, es por el manual de 300
              páginas lleno de términos técnicos que nadie usa en la vida real.
            </p>
            <p data-id="element-155">
              Tratar de memorizar cada tornillo del camión en un idioma que no
              dominas es la receta perfecta para el pánico. Llegas al examen,
              ves palabras como{' '}
              <span className="bg-slate-800 text-amber-400 px-2 py-1 rounded font-mono text-sm" data-id="element-156">
                Slack Adjuster
              </span>{' '}
              o{' '}
              <span className="bg-slate-800 text-amber-400 px-2 py-1 rounded font-mono text-sm" data-id="element-157">
                Pushrod
              </span>
              , te bloqueas, pierdes tu dinero de la cita y regresas a casa con
              las manos vacías y la moral por el suelo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}